import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { Role, homePathForRole } from "./roles";

interface Props {
  allow?: Role[];           // roles permitted; omitted = any authenticated user
  children: React.ReactElement;
}

const ProtectedRoute: React.FC<Props> = ({ allow, children }) => {
  const { isAuthenticated, role } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  if (allow && !allow.includes(role)) {
    return <Navigate to={homePathForRole(role)} replace />;
  }
  return children;
};

export default ProtectedRoute;
